import { server_ip } from "../config";

async function fetchPhotoManagementFiles(token,filter={},options={}) {
    try {
        const response = await fetch(`${server_ip}/api/photoManagementFiles/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                "filter":{...filter},
                "options":{"limit":99,...options}
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function editPhotoManagementFilesRecord(token,_id,data) {
    try {
        const response = await fetch(`${server_ip}/api/photoManagementFiles/${_id}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function createPhotoManagementFilesRecord(token,data) {
    try {
        const response = await fetch(`${server_ip}/api/photoManagementFiles`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function deletePhotoManagementFilesRecord(token,id) {
    try {
        const response = await fetch(`${server_ip}/api/photoManagementFiles/${id}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}

export{
    fetchPhotoManagementFiles,
    editPhotoManagementFilesRecord,
    createPhotoManagementFilesRecord,
    deletePhotoManagementFilesRecord,
}